import { PureComponent } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { VEHICLE_NAME, MAKE_NAME } from 'components/searchAds/constants';
import MakeControl from '../Control';
import mapStateToProps from './mapStateToProps';
import { vehiclePropTypes, vehicleDefaultProps } from '../../constants';

// `null` dispatch: props are spread onto `Field` and reach the DOM control.
class MakeField extends PureComponent {
  static propTypes = {
    ...vehiclePropTypes,
  };

  static defaultProps = {
    ...vehicleDefaultProps,
    component: MakeControl,
    label: __('filterBlocks.titles.make'),
  };

  render() {
    const { fieldIndex } = this.props;

    return (
      <Field
        {...this.props}
        name={`${VEHICLE_NAME}.${fieldIndex}.${MAKE_NAME}`}
      />
    );
  }
}

export default connect(mapStateToProps, null)(MakeField);
